import { render, staticRenderFns } from "./AdminCourseForm.vue?vue&type=template&id=12bd1af5&scoped=true&"
import script from "./AdminCourseForm.vue?vue&type=script&lang=js&"
export * from "./AdminCourseForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminCourseForm.vue?vue&type=style&index=0&id=12bd1af5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd1af5",
  null
  
)

export default component.exports